<div class="cd-page" *ngIf="!loading && company; else loadingTpl">

  <!-- Title row -->
  <div class="cd-title-row">
    <h1 class="cd-title-row__name">{{ company.name }}</h1>
    <span
      class="cd-status cd-status--{{ statusMeta(company.status).cssClass }}"
      *ngIf="company.status"
    >{{ statusMeta(company.status).label }}</span>
    <div class="cd-title-row__actions">
      <button *ngIf="canEdit" class="cd-icon-btn cd-icon-btn--circle" [appCustomTooltip]="VIEW_TOOLTIP.EDIT" tooltipPosition="bottom" aria-label="Edit company" (click)="editCompany()">
        <svg width="20" height="20" viewBox="0 0 18.3266 18.1481" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M6.3764 17.0279L15.1628 5.66544C15.6403 5.0527 15.8101 4.3443 15.6509 3.62299C15.513 2.96726 15.1097 2.34377 14.5049 1.87078L13.0299 0.699064C11.7459 -0.322161 10.1541 -0.214663 9.24152 0.957057L8.25465 2.23735C8.12731 2.39752 8.15914 2.63401 8.31832 2.76301C8.31832 2.76301 10.812 4.76246 10.8651 4.80546C11.0349 4.96671 11.1622 5.1817 11.1941 5.43969C11.2471 5.94493 10.8969 6.41792 10.377 6.48242C10.1329 6.51467 9.89944 6.43942 9.72966 6.29967L7.1086 4.21422C6.98126 4.11855 6.79025 4.13898 6.68413 4.26797L0.455138 12.3303C0.0518985 12.8355 -0.086052 13.4912 0.0518984 14.1255L0.847767 17.5761C0.890213 17.7589 1.04939 17.8879 1.24039 17.8879L4.74222 17.8449C5.37891 17.8341 5.97316 17.5439 6.3764 17.0279Z" fill="currentColor"/>
          <path d="M10.6996 15.6481C10.0092 15.6481 9.44958 16.2078 9.44958 16.8981C9.44958 17.5885 10.0092 18.1481 10.6996 18.1481H17.0766C17.7669 18.1481 18.3266 17.5885 18.3266 16.8981C18.3266 16.2078 17.7669 15.6481 17.0766 15.6481H10.6996Z" fill="currentColor"/>
        </svg>
      </button>
      <button *ngIf="canBlock" class="cd-icon-btn cd-icon-btn--circle" [appCustomTooltip]="VIEW_TOOLTIP.BLOCK" tooltipPosition="bottom" aria-label="Block company" (click)="blockCompany()">
        <svg width="20" height="20" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M7.98828 3.9243e-05C9.40247 -0.00539086 10.7615 0.552906 11.7637 1.55082C12.766 2.54916 13.3291 3.90564 13.3291 5.32035V7.57523C14.9172 8.41289 16 10.0798 16 12V14C16 16.7615 13.7614 19 11 19H5C2.23858 19 0 16.7615 0 14V12C0 10.0798 1.08282 8.41289 2.6709 7.57523V5.32035C2.67095 2.38287 5.0511 0.00138707 7.98828 3.9243e-05ZM8 11C7.44772 11 7 11.4478 7 12V14C7 14.5523 7.44772 15 8 15C8.55228 15 9 14.5523 9 14V12C9 11.4478 8.55228 11 8 11ZM7.99121 2.00004C6.15745 2.00004 4.67095 3.48661 4.6709 5.32035V7.01176C4.77971 7.00469 4.8894 7.00004 5 7.00004H11C11.1106 7.00004 11.2203 7.00469 11.3291 7.01176V5.32035C11.3291 4.43732 10.9773 3.59089 10.3516 2.96781C9.72586 2.3448 8.87809 1.99633 7.99512 2.00004H7.99121Z" fill="currentColor"/>
        </svg>
      </button>
      <button *ngIf="canUnblock" class="cd-icon-btn cd-icon-btn--circle" [appCustomTooltip]="VIEW_TOOLTIP.UNBLOCK" tooltipPosition="left" aria-label="Unblock company" (click)="unblock()">
        <svg width="20" height="20" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M8.31836 3.89667e-05C9.73252 -0.00537189 11.0906 0.552923 12.0928 1.55082C12.4839 1.94053 12.4853 2.5736 12.0957 2.96488C11.706 3.356 11.0729 3.35732 10.6816 2.96781C10.0559 2.34472 9.20727 1.9963 8.32422 2.00004H8.32031C6.4866 2.00009 5.00005 3.48664 5 5.32035V7.00004L11.5127 7.00004C13.9061 7.00004 16 8.797 16 11.1944L16 14.8057C16 17.2031 13.9061 19 11.5127 19H4.4873C2.09388 19 2.24847e-05 17.2031 0 14.8057L0 11.1944C1.7423e-05 9.31351 1.28884 7.80223 3 7.23832L3 5.32035C3.00005 2.38274 5.38101 0.0011836 8.31836 3.89667e-05ZM8 10.7998C7.44772 10.7998 7 11.2476 7 11.7998V14.2998C7 14.8521 7.44772 15.2998 8 15.2998C8.55228 15.2998 9 14.8521 9 14.2998V11.7998C9 11.2476 8.55228 10.7998 8 10.7998Z" fill="currentColor"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- Main two-column layout -->
  <div class="cd-layout">

    <!-- Left: info cards -->
    <div class="cd-main">
      <section class="cd-card" *ngFor="let section of sections">
        <h2 class="cd-card__title">{{ section.title }}</h2>
        <div class="cd-grid">
          <div class="cd-field" *ngFor="let field of section.fields">
            <span class="cd-label">{{ field.label }}</span>
            <span class="cd-value">{{ field.value }}</span>
          </div>
        </div>
      </section>

      <!-- Document preview cards (Figma node 1745:59737): one per document type with files -->
      <section class="cd-card cd-docs" *ngFor="let card of documentCards">
        <h2 class="cd-card__title">{{ card.title }}</h2>
        <div class="cd-docs__list">
          <div class="cd-doc-row" *ngFor="let doc of card.documents">
            <span class="cd-doc-row__icon" aria-hidden="true">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="#ffffff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 2v6h6" stroke="#ffffff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            <div class="cd-doc-row__info">
              <span class="cd-doc-row__name" [title]="doc.name">{{ doc.name }}</span>
              <span class="cd-doc-row__subtitle">{{ doc.subtitle }}</span>
            </div>
            <button type="button" class="cd-doc-row__preview" (click)="openDocumentPreview(doc)">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.8"/>
              </svg>
              {{ DOCUMENT_COPY.PREVIEW }}
            </button>
          </div>
        </div>
      </section>

      <!-- Agency Rebates (read-only, PRD: same sections as the create/edit form) — only for agency companies -->
      <section class="cd-card" *ngIf="company.type_of_company === COMPANY_TYPE.AGENCY && rebates.length">
        <h2 class="cd-card__title">Agency Rebates</h2>
        <div *ngFor="let rebate of rebates; let i = index" class="cd-rebate-row" [class.cd-rebate-row--not-first]="i > 0">
          <div class="cd-field">
            <span class="cd-label">Rebate Currency</span>
            <span class="cd-value">{{ rebate.currency || PLACEHOLDER }}</span>
          </div>
          <div class="cd-field">
            <span class="cd-label">Rebate Threshold</span>
            <span class="cd-value">{{ rebate.rebate_threshold || PLACEHOLDER }}</span>
          </div>
          <div class="cd-field">
            <span class="cd-label">Rebate (%)</span>
            <span class="cd-value">{{ rebate.rebate_percentage || PLACEHOLDER }}</span>
          </div>
        </div>
      </section>
    </div>

    <!-- Right: lifecycle actions + comments -->
    <aside class="cd-sidebar">

      <!-- Lifecycle actions (PRD HU5) -->
      <app-company-approval-actions
        [statusCode]="statusCode"
        (submitForVerification)="submitForVerification()"
        (retryComplianceValidation)="retryComplianceValidation()"
        (forceFinancialValidation)="forceFinancialValidation()"
        (verify)="verify()"
        (returnToKam)="returnToKam()"
        (forceVerification)="forceVerification()"
      ></app-company-approval-actions>

      <!-- Comments -->
      <section class="cd-card cd-card--comments">
        <div class="cd-card__title-row">
          <h2 class="cd-card__title">Comments</h2>
        </div>

        <!-- New comment input -->
        <div class="cd-comment-input" *ngIf="canComment">
          <textarea
            class="cd-comment-input__field"
            placeholder="Add comment"
            [(ngModel)]="newComment"
            (keydown.enter)="addComment()"
            aria-label="Add a comment"
            rows="5"
          ></textarea>
          <div class="cd-comment-input__actions">
            <button type="button" class="cd-comment-input__btn cd-comment-input__btn--send" aria-label="Send comment" (click)="addComment()">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>

        <!-- Comment list -->
        <div class="cd-comments" *ngIf="comments.length > 0">
          <div class="cd-comment" *ngFor="let comment of comments">
            <div
              class="cd-comment__avatar"
              [style.background]="getInitialsColor(comment.initials)"
            >
              {{ comment.initials }}
            </div>
            <div class="cd-comment__bubble">
              <div class="cd-comment__header">
                <span class="cd-comment__author">{{ comment.author }}</span>
                <span class="cd-comment__date">{{ comment.date }}</span>
              </div>
              <p class="cd-comment__text">{{ comment.text }}</p>
            </div>
          </div>
        </div>

        <p class="cd-comments--empty" *ngIf="comments.length === 0">No comments yet</p>
      </section>

    </aside>

  </div>
</div>

<ng-template #loadingTpl>
  <div class="cd-skeleton">
    <!-- Title row skeleton -->
    <div class="cd-skeleton__title-row">
      <div class="cd-skeleton__bar cd-skeleton__bar--title"></div>
      <div class="cd-skeleton__bar cd-skeleton__bar--badge"></div>
    </div>

    <div class="cd-layout">
      <!-- Left column: info cards -->
      <div class="cd-main">
        <div class="cd-skeleton__card" *ngFor="let card of skeletonCards">
          <div class="cd-skeleton__bar cd-skeleton__bar--card-title"></div>
          <div class="cd-skeleton__grid">
            <div class="cd-skeleton__bar cd-skeleton__bar--field" *ngFor="let f of card.fields"></div>
          </div>
        </div>
      </div>

      <!-- Right column: sidebar cards -->
      <div class="cd-sidebar">
        <div class="cd-skeleton__card" *ngFor="let card of skeletonSidebarCards">
          <div class="cd-skeleton__bar cd-skeleton__bar--card-title"></div>
          <div class="cd-skeleton__grid">
            <div class="cd-skeleton__bar cd-skeleton__bar--field" *ngFor="let f of card.fields"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
